import globals from "../globals.js"
import currencies from '../json/currency.json';
export default {
    data() {
        return {

        }
    },
    computed: {
        // Currency of the logged-in user (from auth/get_loggedin_user), e.g. { label: "INR(₹)", symbol: "₹" }.
        user_currency() {
            let user = this.$store.getters.loggedInUser || {};
            return this.findCurrency(user.currency) || { name: 'USD', symbol: '$' };
        },
        currency_symbol() {
            return this.user_currency.symbol || '$';
        },
        currency_locale() {
            return this.currencyLocale(this.user_currency.name);
        },
    },
    methods:{

        getCompanyById(id) {
            return new Promise(async (resolve, reject) => {
                try {
                    let response = await this.$http.get(globals.AUTH_SERVICE + "/company/" + id)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                }
                catch(error)  {
                    reject(error.response.data.reason)
                }
            })
        },
        // Currency may be saved as an object, a code ("INR"), a label ("INR(₹)") or a symbol ("₹").
        findCurrency(currency) {
            if (!currency) return null;
            let values = typeof currency == 'object' ? [currency.name, currency.label, currency.symbol, currency.value, currency.code] : [currency];
            values = values.filter(Boolean).map(x => String(x).trim());
            return currencies.find(x => values.some(v => v == x.name || v == x.label || v.startsWith(x.name + '(')))
                || currencies.find(x => values.some(v => v == x.symbol))
                || (typeof currency == 'object' && currency.symbol ? currency : null);
        },
        // South Asian currencies group digits as 1,00,00,000; the rest use 10,000,000.
        currencyLocale(currency_name) {
            return ['INR', 'PKR', 'BDT', 'NPR', 'LKR'].includes(currency_name) ? 'en-IN' : 'en-US';
        },
        // Grouped manually instead of toLocaleString, which ignores en-IN on browsers without full locale data.
        groupDigits(int_part) {
            if ((this.currency_locale || 'en-US') == 'en-IN' && int_part.length > 3) {
                let last_three = int_part.slice(-3);
                let rest = int_part.slice(0, -3).replace(/\B(?=(\d{2})+(?!\d))/g, ',');
                return rest + ',' + last_three;
            }
            return int_part.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        formatNumber(value) {
            if (value == null || value === '') return '-';
            let [int_part, dec_part] = (Math.round(Number(value) * 100) / 100).toString().split('.');
            let sign = int_part.startsWith('-') ? '-' : '';
            let grouped = sign + this.groupDigits(int_part.replace('-', ''));
            return dec_part ? grouped + '.' + dec_part : grouped;
        },
        // Adds grouping commas to a number being typed, keeping up to 2 decimals when allow_decimal is set.
        formatInputNumber(value, allow_decimal) {
            let cleaned = String(value || '').replace(allow_decimal ? /[^0-9.]/g : /[^0-9]/g, '');
            let dot_index = cleaned.indexOf('.');
            let int_part = dot_index < 0 ? cleaned : cleaned.slice(0, dot_index);
            let dec_part = dot_index < 0 ? null : cleaned.slice(dot_index + 1).replace(/\./g, '').slice(0, 2);
            int_part = int_part.replace(/^0+(?=\d)/, '');
            let formatted = int_part ? this.groupDigits(int_part) : '';
            return dec_part === null ? formatted : (formatted || '0') + '.' + dec_part;
        },
        addStakeholderInvestment(params) {
            return new Promise(async (resolve, reject) => {
                try {
                    let response = await this.$http.post(globals.AUTH_SERVICE + "/stakeholder/shares/add", params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason || response.data.message)
                    }
                }
                catch(error) {
                    reject(error.response ? error.response.data.reason : error)
                }
            })
        },
        getInvestmentHistory(params) {
            return new Promise(async (resolve, reject) => {
                try {
                    let response = await this.$http.post(globals.AUTH_SERVICE + "/stakeholder/shares/history", params)
                    // The API may return the investments as a plain array instead of { status_id, investments }.
                    if (Array.isArray(response.data)) {
                        resolve({ investments: response.data })
                    } else if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason || response.data.message)
                    }
                }
                catch(error) {
                    reject(error.response ? error.response.data.reason : error)
                }
            })
        },
        // Companies apis
        createStakeholder(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.AUTH_SERVICE + "/stakeholder/", params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        getStakeholderById(id) {
            return new Promise(async (resolve, reject) => {
                try {
                    let response = await this.$http.get(globals.AUTH_SERVICE + "/stakeholder/" + id)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                }
                catch(error) {
                    reject(error.response.data.reason)
                }
            })
        },
        editStakeholder(params, id) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.patch(globals.AUTH_SERVICE + "/stakeholder/" + id, params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        deleteStakeholder(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.delete(globals.AUTH_SERVICE + `/stakeholder/delete`, {
                        data: params
                    })
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        getStakeholderList(skip, limit, search_key,company_id,role) {
            return new Promise(async (resolve, reject) => {
                try {
                    let response = await this.$http.get(globals.AUTH_SERVICE + `/stakeholder/?skip=${skip}&limit=${limit}&search_key=${search_key}&company_id=${company_id}&role=${role}`)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                }
                catch(error) {
                    reject(error.response.data.reason)
                }
            })
        },
        regenerateStakeholder(params) {
            return new Promise(async (resolve, reject) => {
                try {
                    let response = await this.$http.post(globals.AUTH_SERVICE + "/stakeholder/details/regenerate", params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                }
                catch(error) {
                    reject(error.response.data.reason)
                }
            })
        },
        checkEmailExit(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.AUTH_SERVICE + "/stakeholder/check/if_email_exist", params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        // reject(response.data.message)
                        resolve(response.data)
                        this.warning_msg = response.data.message
                        // this.$refs.warning_modal.open();
                        // setTimeout(() => {
                        //     this.$refs.warning_modal.close();
                        // }, 3000);
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.message
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        getNewProducts(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.AUTH_SERVICE + "/stakeholder/product_role_list/", params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        // reject(response.data.message)
                        resolve(response.data)
                        this.warning_msg = response.data.message
                        // this.$refs.warning_modal.open();
                        // setTimeout(() => {
                        //     this.$refs.warning_modal.close();
                        // }, 3000);
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.message
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
    }
}
